export default __webpack_public_path__ + "static/media/stairs-down.inline.3a3c04e4.svg";